





















































































































import { MobileAppReleaseApi } from "../api/MobileAppReleaseApi";
import { DateUtils } from "../utils/DateUtils";

export default {
    name: "MobileAppReleasesList",
    data() {
        return {
            releases: [],
            loading: false,
            uploading: false,
            MobileAppReleaseApi: new MobileAppReleaseApi(),
        };
    },
    created() {
        this.loadReleases();
    },
    methods: {
        loadReleases() {
            let self = this;
            self.loading = true;

            return self.MobileAppReleaseApi.getAll()
                .then(function (response) {
                    self.releases = response.data;
                })
                .catch(function (error) {
                    self.releases = [];
                    console.error("Error loading mobile app releases:", error);
                })
                .finally(function () {
                    self.loading = false;
                });
        },
        handleFiles(event) {
            let self = this;
            let file = _.first(event.target.files);

            if (!file || self.uploading) {
                return;
            }

            self.uploading = true;

            self.MobileAppReleaseApi.upload(file)
                .then(function (response) {
                    self.loadReleases();
                    swal(
                        "La version " +
                            response.data.data.version_name +
                            " a été ajoutée !",
                        "",
                        "success"
                    );
                })
                .catch(function (error) {
                    swal(
                        "Erreur",
                        error.response && error.response.data.message
                            ? error.response.data.message
                            : "L'upload de l'APK a échoué.",
                        "error"
                    );
                })
                .finally(function () {
                    self.uploading = false;
                    event.target.value = "";
                });
        },
        confirmSetDefault(release) {
            let self = this;

            if (release.is_default) {
                return;
            }

            swal({
                title:
                    "Distribuer la version " +
                    release.version_name +
                    " par défaut ?",
                text: "L'application mobile proposera cette version au téléchargement.",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success",
                confirmButtonText: "Oui",
                cancelButtonClass: "btn btn-default",
                cancelButtonText: "Non",
                buttonsStyling: false,
            }).then(function () {
                self.MobileAppReleaseApi.setDefault(release.id).then(
                    function () {
                        self.loadReleases();
                        swal(
                            "La version " +
                                release.version_name +
                                " est maintenant distribuée !",
                            "",
                            "success"
                        );
                    }
                );
            });
        },
        confirmDelete(release) {
            let self = this;

            swal({
                title:
                    "Voulez-vous supprimer l'APK " +
                    release.version_name +
                    " ?",
                text: "",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success",
                confirmButtonText: "Oui",
                cancelButtonClass: "btn btn-default",
                cancelButtonText: "Non",
                buttonsStyling: false,
            }).then(function () {
                self.MobileAppReleaseApi.delete(release.id).then(function () {
                    self.loadReleases();
                    swal("L'APK a été supprimé !", "", "success");
                });
            });
        },
        // UI
        formatSize(bytes) {
            if (bytes >= 1024 * 1024) {
                return (
                    (bytes / (1024 * 1024)).toFixed(1).replace(".", ",") +
                    " Mo"
                );
            }

            return Math.round(bytes / 1024) + " Ko";
        },
        formatDate(date) {
            return DateUtils.sqlToDateStr(date);
        },
    },
};
